import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ScrollAnimation from './directives/scrollamination'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.config.productionTip = false
Vue.directive('scrollanimation', ScrollAnimation)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
